import { createContext } from "react"

/** The name of the record a detail page is showing, for the top bar's last crumb. */
export interface BreadcrumbState {
  label: string | null
  setLabel: (label: string | null) => void
}

export const BreadcrumbContext = createContext<BreadcrumbState>({
  label: null,
  setLabel: () => undefined,
})
